import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
    formType: ''
};

const roleUserSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setFormType: (state, action) => {
            state.formType = action.payload;
        }

    }
});

export const { setFormType } = roleUserSlice.actions;

export default roleUserSlice.reducer;